export function copyObject(object, options) {
  const objectCopy = {};
  Object.getOwnPropertyNames(object).forEach(key => {
    if (options && options.excludeKeys && options.excludeKeys.includes(key)) {
      return;
    }
    objectCopy[key] = object[key];
  });
  return objectCopy;
}